<template>
  <div class="third APPAbnormalCondition">
    <div class="third-formOne personalCenter">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-content">APP异常情况说明配置</span>
        </div>
        <div class="btn-right">
          <el-button @click="Reset()"
                     class="btn-two"
                     type="default">重置</el-button>
          <el-button @click="Preservation()"
                     class="btn-two"
                     type="primary"
                     v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <div class="formOne-forms">
        <div class="forms-one"
             style="margin-top: 57px;">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">异常情况处理说明配置</span>
            </div>
          </div>
          <div class="one-list my-from-label">
            <div style="fontSize:14px;margin: 15px 0;font-weight: 600;">用户网络不可用</div>
            <wangEditor @getContent='getContent1'
                        height='300px'
                        editorId='Network-Unavailable'
                        ref="wangEditor1"> </wangEditor>
            <div style="fontSize:14px;margin: 15px 0;font-weight: 600;">无法连接服务器</div>
            <wangEditor @getContent='getContent2'
                        height='300px'
                        editorId='NO-server'
                        ref="wangEditor2"> </wangEditor>
            <div style="fontSize:14px;margin: 15px 0;font-weight: 600;">服务异常</div>
            <wangEditor @getContent='getContent3'
                        height='300px'
                        editorId='Service-exceptions'
                        ref="wangEditor3"> </wangEditor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { addxuexiao, selectxuexiao } from "@/api/baseData/xuexiao";
import {
  getAppStartImage,
  deleteStartImage,
  saveAppStartImage
} from "@/store/appconfig/adhibitionJPG"; //我的
import wangEditor from "@/views/APP-SERVICE-SETTING/wangEditor/index.vue";

export default {
  name: "formSeven",
  props: ["IDlist"],
  components: {
    // addOfficalAccounts
    wangEditor,
  },
  data () {
    return {
      hideUpload: false,
      radio: "",
      radio_img: "", //选择图片
      countNum: 1, //用于显示第一个错误
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // },
      ], // 上传文件列表
      pointList: [],
      rules: {
        icon: [
          { required: true, message: "请添加学校启动图", trigger: "blur" }
        ],
        chooseGuest: [
          { required: true, message: "请选择学校访客模式配置", trigger: "blur" }
        ],
      },
      ruleForm: {
        serNetworkUn: "", //用户网络不可用
        unConnectServer: "", //无法连接服务器
        serviceException: "", //服务异常
      },
      fileListlength: 0,
      upload_img: [] //上传图片数据
    };
  },
  created () {
    // this.getAppStartImageFN();
    this.platformappsexceptionconfigDetail()
  },
  watch: {
    'fileList.length' () {
      this.fileList.length > 8 ? this.hideUpload = true : this.hideUpload = false
    }
  },
  methods: {
    getContent1 (html, arr) {
      // console.log(html, arr);
      this.ruleForm.userNetworkUn = html
      this.ruleForm.userNetworkUnStr = JSON.stringify(arr)
    },
    getContent2 (html, arr) {
      // console.log(html, arr);
      this.ruleForm.unConnectServer = html
      this.ruleForm.unConnectServerStr = JSON.stringify(arr)
    },
    getContent3 (html, arr) {
      // console.log(html, arr);
      this.ruleForm.serviceException = html
      this.ruleForm.serviceExceptionStr = JSON.stringify(arr)
    },
    async platformappsexceptionconfigDetail () {
      const { data: { result, status, msg } } = await this.$store.dispatch('platformappsexceptionconfigDetail', {})
      console.log(result);
      if (status === 1000) {
        Object.assign(this.ruleForm, result)
        this.$refs.wangEditor1.reset(JSON.parse(result.userNetworkUnStr))
        this.$refs.wangEditor2.reset(JSON.parse(result.unConnectServerStr))
        this.$refs.wangEditor3.reset(JSON.parse(result.serviceExceptionStr))
        console.log(this.ruleForm);
      } else {
        this.$message.error(msg)
      }
    },
    async platformappsexceptionconfigSave () {
      const { data: { result, status, msg } } = await this.$store.dispatch('platformappsexceptionconfigSave', {
        userNetworkUn:this.ruleForm.userNetworkUn,
        userNetworkUnStr:this.ruleForm.userNetworkUnStr,
        unConnectServer:this.ruleForm.unConnectServer,
        unConnectServerStr:this.ruleForm.unConnectServerStr,
        serviceException:this.ruleForm.serviceException,
        serviceExceptionStr:this.ruleForm.serviceExceptionStr,
        id:this.ruleForm.id,
      })
      console.log(result);
      if (status === 1000) {
        this.$message.success('保存成功')
      } else {
        this.$message.error(msg)
      }
    },
    //重置
    Reset () {
      this.platformappsexceptionconfigDetail()
    },
    //保存
    Preservation () {
      this.platformappsexceptionconfigSave()
    },
  }
};
</script>

<style lang="scss">
.APPAbnormalCondition {
  .w-e-text-placeholder {
    top: 4px !important;
  }
}
.my-upload-qdt {
  // width: 100px;
  float: left;
  position: relative;
  .el-upload--picture-card {
    float: left;
    overflow: hidden;
  }
  .list-upload-tip {
    width: 400px;
    position: absolute;
    left: 0;
    bottom: -25px;
  }
}
.my-from-label {
  .el-form {
    .first {
      .el-form-item__label:nth-child(1) {
        padding-top: 15px !important;
      }
    }
  }
}
.change_dispaly:hover .change_div {
  display: block !important;
}
// .change_div:hover {
// display: block
// border: 1px solid red;
// }
.slideshow {
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
  .fileleft {
    overflow: hidden;
    .el-upload--picture-card {
      float: left !important;
      margin-right: 8px !important;
    }
  }
}
.hide .el-upload--picture-card {
  // display: none;
  opacity: 0;
}
</style>
